import {NgModule, Component, OnInit, OnChanges, ViewChild, Input, Output,EventEmitter} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import {FormsModule} from "@angular/forms";

import {BrowserModule}   from '@angular/platform-browser';
import {DialogModule,ButtonModule, GMapModule, InputTextModule} from 'primeng/primeng';

import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../translate/translate.module.pipe";
import {TranslateServiceForm} from "../translate/translate.service"; // ADD THIS

declare var google: any;

@Component({
    selector:'selector-gmap',
    templateUrl:'./gmap.html'
})
export class GmapComponent implements OnInit, OnChanges {

  @ViewChild("gmap") google_map : any;

  _gmap_show : boolean;
  _location_show : boolean;

  _gmap_show_type : string;
  _overlay_data : string;
  _location_show_type : string;

  private logger : Logger = new Logger();

  @Input() set gmap_show (gmap_show : boolean) {
    this._gmap_show = gmap_show;
    this.logger.debug("type :", this._gmap_show_type);
    let over = this;
    if(this._gmap_show == true) {
      setTimeout(() => {
        this.logger.debug("ngOnChanges gmap show :" , this.gmap_show);
        if(this._gmap_show_type == 'add'){
          this.gps_options = {
            center: new google.maps.LatLng(37.566286, 126.977828),
            zoom: 17
          };

          this.map = new google.maps.Map(this.google_map.el.nativeElement.children[0], this.gps_options);
          over.overlays = [];
          google.maps.event.addListener(this.map, 'click', function(event) {
            over.addMarker(event);
          });

        } else if(this._gmap_show == true && this._gmap_show_type == 'detail') {
          this.selectDetailGps(this._overlay_data);
          google.maps.event.addListener(this.map, 'click', function(event) {
            over.addMarker(event);
          });
        }
      }, 1000);
    } else {
      alert("else");
    }



  }

  @Input() set gmap_show_type ( gmap_show_type : string) {
    this._gmap_show_type = gmap_show_type;
    this.logger.debug("_gmap_show_type :" , gmap_show_type)
  }

  @Input() set overlay_data (overlay_data : string) {
    this._overlay_data = overlay_data;
    this.logger.debug("_overlay_data :" , overlay_data)
  }

  @Input() set location_show_type(location_show_type : string ) {
    this.logger.debug("location_show_type :" , location_show_type);
    this._location_show_type = location_show_type;
    this.logger.debug("222 :", this._location_show_type);
  }

  @Input() set location_show(location_show : boolean) {
    this._location_show = location_show;
    this.logger.debug("_location_show :" , location_show);
    setTimeout(() => {
      this.gps_options = {
          center: new google.maps.LatLng(37.566286, 126.977828),
          zoom: 17
      };
      this.location_map = new google.maps.Map(this.google_map.el.nativeElement.children[0], this.gps_options);
      this.logger.debug("location map " , this.location_map);
    } , 1000);


  }


  @Input()  _action_clear : boolean;
  @Output() _create_gps = new EventEmitter();
  @Output() _location_data = new EventEmitter();

  create_gps : string;

  gps_options : any;
  map : any;
  location_map : any;
  gps_search : string;

  overlays: any[] = [];
  self : any;
  polyGonCoords : any[] = [];

  markers : any[] = [];
  polygons : any[] = [];
  add_marker_latlng : any[] = [];
  add_marker_polylines : any[] = [];
  location_data : any;
  address : string;
  translate : TranslateServiceForm;
  constructor(private _translate:TranslateServiceForm){
    this.translate = _translate;
  }

  ngOnInit() {

  }

  ngOnChanges(changes: any) {

  }

  gps_search_admin(data) {
    var geocoder = new google.maps.Geocoder();
    if(!data) {
  		alert(this.translate.instant('MESSAGE_Enter_Address'));
  		return;
    }

    var g_map = this.google_map;
    let over = this;

    var test = geocoder.geocode( {'address': data}, function(results, status) {
      this.logger.debug("this._location_show_type :", over._location_show_type);
      if(over._location_show_type &&over._location_show_type == 'location') {
        over.search_location(results, status);
      } else {
        over.search_gps(results, status);
      }

    });
  }

  search_location(results, status) {
    this.markers.forEach(gps=> { gps.setMap(null);});
    let formatted_address = results[0].formatted_address;
    this.logger.debug("formatted_address :", formatted_address);
    this.location_map.setCenter(results[0].geometry.location);
    let marker = new google.maps.Marker({position:{lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng()}, map: this.location_map})
    this.markers.push(marker);
    this.address = formatted_address;
  }

  search_gps(results, status) {
    if(status == google.maps.GeocoderStatus.OK) {
      this.gps_options = {
        center : {lat : results[0].geometry.location.lat() , lng : results[0].geometry.location.lng()},
        zoom: 17
      }
      try{
        this.logger.debug("thismap :", this.map);
        this.map.setCenter(results[0].geometry.location);
      } catch(e) {
        this.logger.debug("e ->", e)
      }
    }
  }

  addMarker(event){
    let lat = event.latLng.lat();
    let lng = event.latLng.lng();


    if(this.polygons.length >= 1) {
      return;
    }

    // 빨간 선 긋기.
    this.add_marker_latlng.push(new google.maps.LatLng(event.latLng.lat(), event.latLng.lng()));
    this.logger.debug("add_marker_latlng :" , this.add_marker_latlng);
    this.logger.debug(this.add_marker_polylines);
    var flightPath = new google.maps.Polyline({
      path: this.add_marker_latlng,
      geodesic: true,
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 2,
      map : this.map
    });
    this.add_marker_polylines.push(flightPath);


    let marker = new google.maps.Marker({position:{lat: lat, lng: lng}, map: this.map})
    this.polyGonCoords.push(event.latLng);
    this.markers.push(marker);

  }

  selectDetailGps(gps) {
    this.logger.debug("gps L : ", gps);
    try {
      let latlng_arr = [];
      let gps_obj = [];
      let gps_overlays : string[] = String(gps.locationGPS).split("|");
      gps_overlays.forEach(gps => {
        this.logger.debug("gps ->", gps);
        let location = gps.split("^");
        let obj = {
          k : Number(location[0]),
  				D : Number(location[1])
        }
        gps_obj.push(obj);
        latlng_arr.push(new google.maps.LatLng(obj.k, obj.D));
      })

      this.gps_options = {
        center: new google.maps.LatLng(Number(gps_obj[0].k), Number(gps_obj[0].D)),
        zoom: 17
      };
      this.map = new google.maps.Map(this.google_map.el.nativeElement.children[0], this.gps_options);
      this.logger.debug("siasia -> detail");

      gps_obj.forEach(gps => {
        this.logger.debug(gps)
        let marker = new google.maps.Marker({position:{lat: gps.k, lng: gps.D}, map : this.map});
        this.markers.push(marker)
        this.logger.debug("this.markers" , this.markers);
      })

      this.markers.forEach(gps => {
        if(!this.create_gps) this.create_gps = gps.position.lat() + "^" + gps.position.lng();
        else this.create_gps = this.create_gps + "|" + gps.position.lat() + "^" + gps.position.lng();
      });


      this.logger.debug("latlng_arr :", latlng_arr);
      let flightPath = new google.maps.Polyline({
		    path: latlng_arr,
		    geodesic: true,
		    strokeColor: '#FF0000',
		    strokeOpacity: 1.0,
		    strokeWeight: 2,
        map : this.map

	    });
      this.add_marker_polylines.push(flightPath);

      this.logger.debug("polygond")
      let polygon = new google.maps.Polygon
        ({paths:latlng_arr,
                strokeOpacity: 0.5,
                strokeWeight: 1,
                fillColor: '#1976D2',
                fillOpacity: 0.35,
                map : this.map
              }
       );
      this.polygons.push(polygon);
    } catch(e) {
      this.logger.debug(e);
    }

    this._create_gps.emit(this.create_gps);


  }

  add_polygon(event) {
    this.logger.debug("================================ add_ploygon_추가 ====================================== ")
    this.logger.debug("final markers :", this.markers);
    this.logger.debug("================================ add_ploygon_추가 ====================================== ")
    if(this.markers.length <= 2) {
      alert(this.translate.instant('MESSAGE_Three_Or_More_Coordinates'));
      return;
    }
    let polygon = new google.maps.Polygon({
      paths: this.polyGonCoords,
      strokeOpacity: 0.5,
      strokeWeight: 1,
      fillColor: '#1976D2',
      fillOpacity: 0.35,
      map : this.map
    })

    this.markers.forEach(gps => {
      if(!this.create_gps) this.create_gps = gps.position.lat() + "^" + gps.position.lng();
      else this.create_gps = this.create_gps + "|" + gps.position.lat() + "^" + gps.position.lng();
    });

    this.logger.debug("polyGon -> : ", this.polyGonCoords);
    this.logger.debug("this._create_gps :", this._create_gps);
    this.polygons.push(polygon);
    this._create_gps.emit(this.create_gps);
  }

  // location 추가
  add_location_info(event) {
    this.logger.debug("this marker :", this.markers);
    this.logger.debug(" this.location_data : " , this.address);
    try {
      this.location_data = {'address' : this.address, 'lat' : this.markers[0].position.lat(), 'lng' : this.markers[0].position.lng()}
      this._location_data.emit(this.location_data);
    } catch(e){
      this.logger.debug("catch :", e);
    }

  }

  gps_reset() {
    this.polyGonCoords = [];
    this.overlays = [];
    this.polygons.forEach(polygon=>{
      polygon.setMap(null);
    })
    this.polygons = [];
    this.logger.debug("markers => :", this.markers);
    this.markers.forEach(marker => {
      marker.setMap(null);
    })
    this.markers = [];
    this.create_gps = "";
    this.add_marker_polylines.forEach(polyLine => {
      polyLine.setMap(null);
    })
    this.add_marker_polylines = [];

    // this.add_marker_latlng.forEach(latLng => {
    //   latLng.setMap(null);
    // })
    this.add_marker_latlng = [];
  }


}

@NgModule({
    imports:[GMapModule, DialogModule, ButtonModule, BrowserModule, InputTextModule, FormsModule, TranslatePipeMoudle],
    declarations:[GmapComponent],
    exports:[GmapComponent],
    providers:[]
})
export class CustomGMapModule{
}



// WEBPACK FOOTER //
// ./src/app/component/gmap.component.ts